<div>
  @if (userCompanyId(); as userCompanyId) {
    @for (doc of documents().items; track doc.id) {
      <lib-deca-list-item
        [document]="doc"
        [userCompanyId]="userCompanyId"
        [detailRoute]="detailRoute()"
      ></lib-deca-list-item>
    } @empty {
      <lib-empty-result text="deca.today.empty"></lib-empty-result>
    }
  }
</div>
